import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {Subject} from 'rxjs';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {take} from 'rxjs/operators';
import {GridValueChangeEvent} from '@shared/models/common.models';
import {AuthApiService} from '@core/services/auth-api.service';
import {FileManagementService} from "@core/services/file-management.service";

@Injectable({
  providedIn: 'root'
})
export class ScenarioConfigurationHandler implements IPlatformToolHandler {
 constructor(private commandService: CommandService,
              private router: Router,
              private dialogService: DialogService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private snackBarService: SnackBarService,
              private authApiService: AuthApiService,
              private fileManagementService: FileManagementService
  ) {
    this.invalidateSubject = new InvalidateSubject();
  }
  magicLinkModel: MagicLinkModel;
  ngUnsubscribe = new Subject<void>();
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter<any>();
  invalidateSubject: InvalidateSubject;
  selectedTab: TabModel;


  executeCommand(command: PlatformCommand) {
    switch (command.name) {
      default:
        this.executeCommandApi(command);
        break;
    }
  }

  private executeCommandApi(command: PlatformCommand) {
    console.log('[Executing PlatformCommand] -> ', command.name);
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      if (!command.fieldValues['BusyScreenDisabled']) {
        this.fuseSplashScreenService.show();
      }
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(res => {
          console.log('Command Response', res);
          if (res.fieldValues['DownloadUrl']) {
            const downloadUrl = res.fieldValues['DownloadUrl'];
            if (downloadUrl) {
              this.fileManagementService.downloadOneTimeSignedUrl(downloadUrl, res.fieldValues['FileName']);
            }
          }
          if (!command.fieldValues['BusyScreenDisabled']) {
            this.fuseSplashScreenService.hide();
          }
          if (res.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(res.fieldValues['RedirectUrl']);
            return;
          }
          if (res.fieldValues['RedirectAbsoluteUrl']) {
            this.authApiService.logoutUser(res.fieldValues['RedirectAbsoluteUrl']);
            return;
          }
          if (res.fieldValues['RedirectCommand']) {
            this.executeCommand(res.fieldValues['RedirectCommand']);
            return;
          }
          if (res.fieldValues['SnackBarMessage']) {
            const duration = res.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(res.fieldValues['SnackBarMessage'], duration);
          }
          this.invalidateSubject.invalidate();
        },
        error => {
          console.error('Failed ToolBarComponent command', error);
          this.fuseSplashScreenService.hide();
        });
    }
  }

  setSelectedTab(selectedTab: TabModel): void {
  }
  destroy() {
    this.invalidateSubject.close();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private handleActions($event: GridValueChangeEvent) {
    switch ($event.action.id) {
      case 'Edit':
        this.openEditor($event);
        break;
      default:
        if (this.magicLinkModel.additionalCommands[$event.action.id]) {
          const command = this.magicLinkModel.additionalCommands[$event.action.id];
          command.fieldValues['ItemId'] = $event.item.id;
          this.executeCommand(command);
        }
        break;
    }
  }

  valueChanged($event: GridValueChangeEvent) {
    console.log('[Event]', $event);
    if ($event.action) {
      this.handleActions($event);
      return;
    }
    if ($event.fieldDefinition && $event.fieldDefinition.key) {
      const command = this.magicLinkModel.additionalCommands[$event.fieldDefinition.key];
      if (command){
        command.fieldValues['ItemId'] = $event.item.id;
        this.executeCommandApi(command);
      }
    }
  }
  private updateDynamicFieldVisibility(event: any, value: any){
    var UpdateScenarioDynamicFieldVisibilityCommand = this.magicLinkModel.additionalCommands['UpdateScenarioDynamicFieldVisibilityCommand'];
    if (UpdateScenarioDynamicFieldVisibilityCommand) {
      UpdateScenarioDynamicFieldVisibilityCommand.fieldValues['Workbook'] = event.item.cells['Workbook']?.value;
      UpdateScenarioDynamicFieldVisibilityCommand.fieldValues['Worksheet'] = event.item.cells['Worksheet']?.value;
      UpdateScenarioDynamicFieldVisibilityCommand.fieldValues['Row'] = event.item.cells['Row']?.value;
      UpdateScenarioDynamicFieldVisibilityCommand.fieldValues['Column'] = event.item.cells['Column']?.value;
      UpdateScenarioDynamicFieldVisibilityCommand.fieldValues['ScenarioType'] = event.item.cells['ScenarioType']?.value;
      UpdateScenarioDynamicFieldVisibilityCommand.fieldValues['DynamicFieldId'] = event.item.cells['DynamicFieldId']?.value;
      UpdateScenarioDynamicFieldVisibilityCommand.fieldValues['Hidden'] = value;
      this.executeCommandApi(UpdateScenarioDynamicFieldVisibilityCommand);
    }
  }
  private handleDialogResponse(event: any, value: any){
    var fieldDefinnitionKey = event.fieldDefinition.key;
    switch (fieldDefinnitionKey) {
      case 'Hidden':
        this.updateDynamicFieldVisibility(event, value);
        break;
      default:
        break;
    }
  }
  private openEditor(event: any, type: string = '') {
    const sourceType = this.magicLinkModel.tabBar.tabs[0].tabData['SourceType'];
    const minWidth = '800px';
    const maxWidth = '1500px';
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, minWidth, maxWidth,
      sourceType).subscribe(state => {
      if (state.action === 'OK') {
        const value = event.item.cells[event.fieldDefinition.key]?.value;
        this.handleDialogResponse(event, value);
      }
      if (state.action === 'OK' && event.fieldDefinition.metaData['SkipUpdate']) {
        this.invalidateSubject.invalidate();
      }
    });
  }
}
